import { changeStep } from './wizzard.js';

import {
  onVehicleSelected as cartVerifyOnVehicleSelected,
  onVehicleDiscarded as cartVerifyOnVehicleDiscarded,
  AfterInit as cartVerifyAfterInit,
} from './cartPageVerifyFitment.js';

window.Convermax.changeStep = changeStep;
const categorySelectionPageUrl = '/categories/';

const isProductPage = window.document.body.classList.contains('page-type-product');

const baseFitmentFields = ['Make', 'Year', 'Model'];
const extraFitmentFields = [];

const engineFields = [
  'engine_make',
  'engine_family',
  'engine_crank',
  'engine_accessories',
  'engine_modifications',
];

function responseHandler(response) {
  const engineFacets = engineFields
    .map((field) => response.Facets.find((f) => f.FieldName === field))
    .filter(Boolean);

  if (!engineFacets.length) {
    return response;
  }

  const engineData = engineFacets
    .filter((facet) => facet.Values.find((value) => value.Selected))
    .map((facet) => ({
      field: facet.FieldName,
      term: facet.Values.find((value) => value.Selected).Term,
      value: facet.Values.find((value) => value.Selected).Value,
    }));

  if (engineData.length || response.Messages.includes('RequestPanelResponse')) {
    const engineString = engineData.map((facetValue) => facetValue.value).join(' ');

    const engineGarageTitle = document.querySelector('#cm-garage__container .cm_engine-garage-title');
    engineGarageTitle.innerText = engineString.length ? engineString : 'Choose your engine';

    window.Convermax.localStorage.setItem('cm_vehicle-engine-string', engineString);
  }

  return response;
}

const getEngineString = () => {
  return window.Convermax.localStorage.getItem('cm_vehicle-engine-string');
};

window.Convermax.getEngineString = getEngineString;
window.Convermax.InitVerifyMiniCart = cartVerifyAfterInit;

const onVehicleDiscarded = () => {
  cartVerifyOnVehicleDiscarded();
};

const AfterInit = () => {
  cartVerifyAfterInit();
};

const onVehicleSelected = (vehicle) => {
  cartVerifyOnVehicleSelected(vehicle);
};

const updateCallback = () => {
  const engineFacetsChips = [...document.querySelectorAll('.cm_filterChips .facetdiv')].filter((chip) =>
    [...chip.classList].some((c) => engineFields.includes(c)),
  );

  if (engineFacetsChips.length) {
    const engineGarageTitle = document.querySelector('#cm-garage__container .cm_engine-garage-title');

    engineFacetsChips?.forEach((chip) =>
      chip.addEventListener('click', () => {
        const currentEngineJson = window.Convermax.localStorage.getItem('cm_vehicle-engine');
        const currentEngine = currentEngineJson ? JSON.parse(currentEngineJson) : null;

        if (currentEngine) {
          const field = [...chip.classList].find((c) => c.startsWith('engine_'));

          const updatedEngine = currentEngine.filter((engine) => engine.field !== field);

          window.Convermax.localStorage.setItem('cm_vehicle-engine', JSON.stringify(updatedEngine));

          engineGarageTitle.innerText = updatedEngine.length
            ? updatedEngine.map((engine) => engine.value).join(' ')
            : 'Choose your engine';
        }
      }),
    );

    document.querySelector('.cm_FilterChips .cm_filter-chips_button')?.addEventListener('click', () => {
      window.Convermax.localStorage.removeItem('cm_vehicle-engine');
      window.Convermax.localStorage.removeItem('cm_vehicle-engine-string');
      engineGarageTitle.innerText = 'Choose your engine';
    });
  }
};

export default {
  platform: 'bigcommerce',
  searchPageUrl: '/pages/search/',
  AfterInit,
  responseHandler,
  sortFields: ['relevance', 'name', 'name:desc', 'price', 'price:desc'],
  SearchRequestDefaults: {
    pageSize: 36,
  },
  page: {
    getPageType: (defaults) =>
      window.location.pathname === categorySelectionPageUrl ? 'parts' : defaults.getter(),
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [{ pathname: categorySelectionPageUrl, field: 'category' }],
    onVehicleSelected,
    onVehicleDiscarded,
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: '#cm_category-page',
      template: 'SearchPage',
      visibleIf: () => window.location.pathname !== categorySelectionPageUrl,
    },
    {
      name: 'CategoryPageCategoriesCarousel',
      type: 'FacetTiles',
      facetField: 'category',
      visibleIf: () => window.location.pathname !== '/search/',
    },
    {
      name: 'SearchHeader',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields: engineFields,
    },
    {
      name: 'SearchResult',
      updateCallback,
    },
    {
      name: 'SearchBox',
      type: 'SearchBoxDialogButton',
      location: '#quickSearch > .container',
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        insertAfter: '#quick-search-expand',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: {
        selector: '#cm-home-ymm',
        class: 'container',
      },
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 770,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
    },
    {
      name: 'Garage',
      location: { lastChildOf: '#cm-garage__container', class: 'garage-button__container' },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'VerifyFitment',
      location: '.productView-product .productView-fitment',
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FitmentTable',
      location: '#cm-fitment-table',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: {
        lastChildOf: 'body.template-product .productView-description .tabs',
        class: 'tab cm-desktop-fitment-tab',
        wrapper: 'li',
      },
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '#cm_category-list',
      template: 'facetTiles/hierarchicalContainer',
      visibleIf: () => window.location.pathname.includes(categorySelectionPageUrl),
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm-brand-list',
      template: 'facetTiles/alphabeticalContainer',
      view: 'grid',
      isVehicleWidgetDisabled: !!window.document.querySelector('#cm-ymm'),
    },
    {
      name: 'VehicleWidgetDialog',
      type: 'ContextDialog',
      template: 'fitmentSearch/dialog',
    },
    {
      name: 'DialogVehicleWidget_tiles',
      type: 'VehicleTiles',
      doNotRedirectOnVehicleSelect: isProductPage,
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'EngineLookupDialog',
      type: 'ContextDialog',
      template: 'fitmentSearch/engineLookupDialog',
    },
    {
      name: 'EngineLookupDialogButton',
      type: 'DialogButton',
      location: {
        firstChildOf: '#cm-garage__container',
      },
      template: 'fitmentSearch/engineLookupDialogButton',
      dialogName: 'EngineLookupDialog',
    },
    {
      name: 'EngineLookupWidget',
      type: 'RequestPanel',
      shouldBeIsolated: () => true,
      mayDiscardIsolatedSelection: true,
      selectFields: engineFields,
      localStorageKey: 'cm_vehicle-engine',
      isAutoRedirectDisabled: true,
    },
  ],
};
